import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

export default _.merge({
  messages: {
    'es-MX': {
        notFound: 'El recurso solicitado no existe.',
    },
    en: {
      notFound: 'Requested resource not found.',
    }
  }
}, defaultMessages)
